export const USER_LOGGED_IN = "USER_LOGGED_IN";
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";

export const USER_PROFILE_RETURNED = "USER_PROFILE_RETURNED";

export const TASKS_FROM_SERVER = "TASKS_FROM_SERVER";
export const TASK_CREATED = "TASK_CREATED";
export const TASK_UPDATED = "TASK_UPDATED";
export const TASK_REMOVED = "TASK_REMOVED";

export const UI_THEME_CHANGED = "UI_THEME_CHANGED";

export const FS_CONTEXTS_LISTED = "FS_CONTEXTS_LISTED";
export const FS_CONTEXT_CREATED = "FS_CONTEXT_CREATED";
export const FS_CONTEXT_UPDATED = "FS_CONTEXT_UPDATED";

export const FS_DOCUMENTS_LISTED = "FS_DOCUMENTS_LISTED";

export const FS_DOCUMENT_CREATED = "FS_DOCUMENT_CREATED";
export const FS_DOCUMENT_UPDATED = "FS_DOCUMENT_UPDATED";
export const FS_DOCUMENT_DELETED = "FS_DOCUMENT_DELETED";

export const CURRENT_CONTEXT_CHANGED = "CURRENT_CONTEXT_CHANGED";
export const CURRENT_DOCUMENT_CHANGED = "CURRENT_DOCUMENT_CHANGED";

export const ADDED_FILE_TO_TASKLIST = "ADDED_FILE_TO_TASKLIST";
export const CLOSED_FILE_IN_TASKLIST = "CLOSED_FILE_IN_TASKLIST";



// WEBPACK FOOTER //
// ./src/actions/types.js